import { render, staticRenderFns } from "./GetStart.vue?vue&type=template&id=09126a62&scoped=true&"
import script from "./GetStart.vue?vue&type=script&lang=js&"
export * from "./GetStart.vue?vue&type=script&lang=js&"
import style0 from "./GetStart.vue?vue&type=style&index=0&id=09126a62&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09126a62",
  null
  
)

export default component.exports